import type { DealListItem, DealStage } from '../api/deals.client.js';

export const STAGE_ORDER: DealStage[] = ['New', 'Contacted', 'Negotiation', 'Won', 'Lost'];

export interface KanbanCardModel {
  id: string;
  dealId: string;
  title: string;
  contactName: string;
  amountLabel: string;
  tags: string[];
  stage: DealStage;
  nextActivityDue: string | null;
  lastActivityAt: string | null;
}

export interface KanbanColumnModel {
  stage: DealStage;
  title: string;
  count: number;
  cards: KanbanCardModel[];
}

function formatMoney(amount: number | string, currency: string): string {
  const numeric = typeof amount === 'string' ? Number(amount) : amount;
  const safeAmount = Number.isFinite(numeric) ? numeric : 0;
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(safeAmount);
}

function buildContactName(deal: DealListItem): string {
  const first = deal.contact?.firstName?.trim() ?? '';
  const last = deal.contact?.lastName?.trim() ?? '';
  const full = `${first} ${last}`.trim();
  return full.length > 0 ? full : 'Контакт не указан';
}

export function moveDealStage(deals: DealListItem[], dealId: string, toStage: DealStage): DealListItem[] {
  return deals.map((deal) => {
    if (deal.id !== dealId) {
      return deal;
    }

    return {
      ...deal,
      stage: toStage,
    };
  });
}

export function buildKanbanColumns(deals: DealListItem[]): KanbanColumnModel[] {
  return STAGE_ORDER.map((stage) => {
    const stageDeals = deals.filter((deal) => deal.stage === stage);

    return {
      stage,
      title: stage,
      count: stageDeals.length,
      cards: stageDeals.map((deal) => ({
        id: deal.id,
        dealId: deal.id,
        title: deal.title,
        contactName: buildContactName(deal),
        amountLabel: formatMoney(deal.amount, deal.currency),
        tags: deal.tags,
        stage: deal.stage,
        nextActivityDue: deal.nextActivityDue,
        lastActivityAt: deal.lastActivityAt,
      })),
    };
  });
}
